module.exports = __webpack_public_path__ + "europa-5_paper.jpg?613e042709d61242724f81c7251893a0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-5_paper.jpg
// module id = 391
// module chunks = 0